<template>
  <tbody>
    <tr v-for="(item, index) in data" :key="index" :class="[stripe && 'stripe', rowClassName]">
      <td v-for="(cItem, cIndex) in columns" :width="cItem.width" :align="cItem.align" :key="cIndex" :style="{
        'min-width': cItem['min-width'],
        'max-width': cItem['max-width']
      }">{{ item[cItem.prop] }}</td>
    </tr>
  </tbody>
</template>
 
<script>
export default {
  name: 'tableBody',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    stripe: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: String,
      default: ''
    }
  }
};
</script>
 
<style scoped>
.stripe:nth-child(even) {
  background-color: #f8faff;
}

td {
  padding: 0.13rem 0.02rem;
  border-bottom: 0.01rem solid #e8edf0;
  color: #253440;
  word-wrap: break-word;
  word-break: break-all;
}
</style>